<p-toast></p-toast>
<p-blockUI [blocked]="clientInfoIsLoading">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>
<p-toolbar styleClass="">
  <ng-template pTemplate="left">
    <p-button label="New" icon="pi pi-plus" styleClass="p-button-success mr-2" (onClick)="onCreateNewClient($event)" [disabled]="!clientDoesNotChanged" pTooltip="Новая организация" tooltipPosition="top"></p-button>
    <p-button [label]="Delete" icon="pi pi-trash" styleClass="p-button-danger hide-label" (onClick)="buttonClick($event)"
              [disabled]="true" pTooltip="Удалить организацию" tooltipPosition="top"></p-button>
    <p-button label="Export" icon="pi pi-upload" styleClass="p-button-info mr-2 hide-label" pTooltip="Сохранить данные об организации" tooltipPosition="top"></p-button>
  </ng-template>

  <ng-template pTemplate="right">
    <p-menubar [model]="navigationMenu" styleClass="ml-2 mr-2 " />
    <!--<p-button label="Все" icon="pi pi-globe" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openAllTabs($event)" pTooltip="Раскрыть все вкладки" tooltipPosition="top"></p-button>

    <p-button label="Компания" icon="pi pi-briefcase" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openCompanyInfoTab($event)" pTooltip="Общая информация о компании" tooltipPosition="top"></p-button>
    <p-button label="Сотрудники" icon="pi pi-users" [disabled]="!_cliId" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openPersonsTab($event)" pTooltip="Перейти к списку сотрудников компании" tooltipPosition="top"></p-button>
    <p-button label="Отделы" icon="pi pi-cloud" [disabled]="!_cliId" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openDepartmentsTab($event)" pTooltip="Перейти к списку отделов компании" tooltipPosition="top"></p-button>
    <p-button label="Юридические лица" icon="pi pi-share-alt" [disabled]="!_cliId" styleClass="p-button-secondary mr-3 hide-label" (onClick)="openLcosTab($event)" pTooltip="Перейти к списку юридических лиц компании" tooltipPosition="top"></p-button>-->

    <!--<p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="mr-2 p-d-inline-block"></p-fileUpload>-->
    <!--<p-button [label]="Save" icon="pi pi-save" class="p-button-success" (onClick)="buttonSaveAllClick($event)"
          [disabled]="(clientDoesNotChanged && departmentDoesNotChanged && personDoesNotChanged)" pTooltip="Сохранить изменения" tooltipPosition="top"></p-button>-->
  </ng-template>
</p-toolbar>

<!--
  CLIID: number;
  CLISUBSOF: number;
  CLICATEGORY: number;
  CLIENTSNIKNAME: string;
  CLIENTSNAME: string;
  CLIENTCOUNTRY: string;
  CLIENTCITY: string;
  CLIENTADDR1: string;
  CLIENTADR2: string;
  CLIENTZIP: string;
  CLIENTBANK: string;
  CLIENTACCOUNT: string;
  CLIENTREGCODE: string;
  CLIENTVATREGCODE: string;
  CLIENTBANKCODE: string;
  CLEINTBANKCITY: string;
  CLIENTBANKADDR1: string;
  CLENTBANKADDR2: string;
  CLIENTBANKZIP: string;
  CLIENTBANKPHONE: string;
  CLIENTNOTE1: string;
  CLIENTNOTE2: string;
  CLIENTVATREGNUM: string;
  CLIENTBANK2ACC: string;
  CLIENTBANKREGCODE: string;
  CUSTOMERBUISNESSAREA?: string;
  CURID: number;
  CLILOGOID: number;
  CASTCATID: number;
  CLIDOCINDEX: number;
  CLISTAMPID: number;

-->

<div *ngIf="client as cli else loading">
  <p-accordion [multiple]="true" (onOpen)="onTabOpen($event)">
    <div #anchorMain>
      <p-accordionTab [selected]="tabCliInfoSelected" [cache]="false" [disabled]="!_cliId">
        <ng-template pTemplate="header">
          <h3>Организация: {{cli.CLIENTSNIKNAME | pipetrimstr }} ({{_cliId}})</h3>
        </ng-template>
        <p-panel header="Общие данные об организации" appStopAccordionHomeEnd>
          <div class="fluid formgrid grid">
            <div class="field col-12 xl:col-4 sm:col-12">
              <label for="CC1" class="do-not-wrap-text">Краткое наименование <span *ngIf="disallowEditNickname">(запрещено изменение)</span></label>
              <input id="CC1" type="text" pInputText [(ngModel)]="cli.CLIENTSNIKNAME" required
                     [disabled]="disallowEditNickname"
                     [class.field-changed]="hasChangedProperty('CLIENTSNIKNAME')" />
            </div>
            <div class="field col-12 xl:col-8 sm:col-12">
              <label for="CC2" class="do-not-wrap-text">Полное наименование</label>
              <input id="CC2" type="text" pInputText [(ngModel)]="cli.CLIENTSNAME" required
                     [class.field-changed]="hasChangedProperty('CLIENTSNAME')" />
            </div>
            <div class="field col-12 xl:col-4 sm:col-12">
              <label for="CC3" class="do-not-wrap-text">Код ЕДРПОУ</label>
              <div class="flex align-items-center flex-wrap gap-2 w-full">
                <p-inputMask id="CC3" [(ngModel)]="cli.CLIENTREGCODE" autoClear="false" mask="99999999?999"
                             class="flex-1"
                             [style]="{'min-width':'140px'}"
                             [styleClass]="hasChangedProperty('CLIENTREGCODE') ? 'field-changed' : ''">
                </p-inputMask>
                <app-company-register-verify
                  [registrationCode]="cli.CLIENTREGCODE"
                  (apply)="onRegisterVerifyApply($event)">
                </app-company-register-verify>
              </div>
            </div>
            <div class="field col-12 xl:col-4 sm:col-12">
              <label class="block mb-2">{{ client.CLIID === -2 ? 'Заповнити з тексту' : 'Додати контакт з тексту' }}</label>
              <p-button
                label="Розпізнати"
                icon="pi pi-search"
                styleClass="p-button-secondary w-full"
                (onClick)="onOpenPasteToCreate()">
              </p-button>
            </div>
            <div class="field col-12 xl:col-4 sm:col-12">
              <label for="CC4" class="do-not-wrap-text">ИНН</label>
              <input id="CC4" type="text" pInputText [(ngModel)]="cli.CLIENTVATREGCODE"
                     [class.field-changed]="hasChangedProperty('CLIENTVATREGCODE')" />
            </div>
            <div class="field col-12 xl:col-4 sm:col-12">
              <label for="CC5" class="do-not-wrap-text">Номер н/с</label>
              <input id="CC5" type="text" pInputText [(ngModel)]="cli.CLIENTVATREGNUM"
                     [class.field-changed]="hasChangedProperty('CLIENTVATREGNUM')" />
            </div>
            <div class="field col-12">
              <label for="CC6" class="do-not-wrap-text">Примечание</label>
              <input id="CC6" type="text" pInputText [(ngModel)]="cli.CLIENTNOTE1"
                     [class.field-changed]="hasChangedProperty('CLIENTNOTE1')" />
            </div>
            <div class="field col-12">
              <label for="CC7" class="do-not-wrap-text">Примечание</label>
              <input id="CC7" type="text" pInputText [(ngModel)]="cli.CLIENTNOTE2"
                     [class.field-changed]="hasChangedProperty('CLIENTNOTE2')" />
            </div>
          </div>
          <p-panel header="Адрес организации" styleClass="mb-3">
            <div class="fluid formgrid grid">
              <div class="field col-12 xl:col-2 sm:col-12">
                <label for="CA1" class="do-not-wrap-text">Почтовый индекс</label>
                <input id="CA1" type="text" pInputText [(ngModel)]="cli.CLIENTZIP"
                       [class.field-changed]="hasChangedProperty('CLIENTZIP')" />
              </div>
              <div class="field col-12 xl:col-4 sm:col-12">
                <label for="CA2" class="do-not-wrap-text">Страна</label>
                <input id="CA2" type="text" pInputText [(ngModel)]="cli.CLIENTCOUNTRY"
                       [class.field-changed]="hasChangedProperty('CLIENTCOUNTRY')" />
              </div>
              <div class="field col-12 xl:col-6 sm:col-12">
                <label for="CA3" class="do-not-wrap-text">Город</label>
                <input id="CA3" type="text" pInputText [(ngModel)]="cli.CLIENTCITY"
                       [class.field-changed]="hasChangedProperty('CLIENTCITY')" />
              </div>
              <div class="field col-12 xl:col-6 sm:col-12">
                <label for="CA4" class="do-not-wrap-text">Адрес</label>
                <input id="CA4" type="text" pInputText [(ngModel)]="cli.CLIENTADDR1"
                       [class.field-changed]="hasChangedProperty('CLIENTADDR1')" />
              </div>
              <div class="field col-12 xl:col-6 sm:col-12">
                <label for="CA5" class="do-not-wrap-text">Доп адрес</label>
                <input id="CA5" type="text" pInputText [(ngModel)]="cli.CLIENTADR2"
                       [class.field-changed]="hasChangedProperty('CLIENTADR2')" />
              </div>
            </div>
          </p-panel>
          <p-panel header="Счета и банки" styleClass="mb-3">
            <div class="fluid formgrid grid">
              <div class="field col-12 xl:col-6 sm:col-12">
                <label for="CB1" class="do-not-wrap-text">Расчетный счет</label>
                <input id="CB1" type="text" pInputText [(ngModel)]="cli.CLIENTACCOUNT" [value]="cli.CLIENTACCOUNT | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIENTACCOUNT')" />
              </div>
              <div class="field col-12 xl:col-2 sm:col-6">
                <label for="CB2" class="do-not-wrap-text">Код банка</label>
                <input id="CB2" type="text" pInputText [(ngModel)]="cli.CLIENTBANKCODE" [value]="cli.CLIENTBANKCODE | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIENTBANKCODE')" />
              </div>
              <div class="field col-12 xl:col-4 sm:col-6">
                <label for="CB3" class="do-not-wrap-text">Наименование банка</label>
                <input id="CB3" type="text" pInputText [(ngModel)]="cli.CLIENTBANK" [value]="cli.CLIENTBANK | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIENTBANK')" />
              </div>
              <div class="field col-12 xl:col-3 sm:col-6">
                <label for="CB4" class="do-not-wrap-text">Код ЕДРПУО банка</label>
                <input id="CB4" type="text" pInputText [(ngModel)]="cli.CLIENTBANKREGCODE" [value]="cli.CLIENTBANKREGCODE | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIENTBANKREGCODE')" />
              </div>
              <div class="field col-12 xl:col-3 sm:col-6">
                <label for="CB9" class="do-not-wrap-text">Телефон банка</label>
                <input id="CB9" type="text" pInputText [(ngModel)]="cli.CLIENTBANKPHONE" [value]="cli.CLIENTBANKPHONE | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIENTBANKPHONE')" />
              </div>
              <div class="field col-12 xl:col-3 sm:col-6">
                <label for="CB5" class="do-not-wrap-text">Почтовый индекс</label>
                <input id="CB5" type="text" pInputText [(ngModel)]="cli.CLIENTBANKZIP" [value]="cli.CLIENTBANKZIP | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIENTBANKZIP')" />
              </div>
              <div class="field col-12 xl:col-3 sm:col-6">
                <label for="CB6" class="do-not-wrap-text">Город</label>
                <input id="CB6" type="text" pInputText [(ngModel)]="cli.CLEINTBANKCITY" [value]="cli.CLEINTBANKCITY | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLEINTBANKCITY')" />
              </div>
              <div class="field col-12 xl:col-6 sm:col-6">
                <label for="CB7" class="do-not-wrap-text">Адрес банка</label>
                <input id="CB7" type="text" pInputText [(ngModel)]="cli.CLIENTBANKADDR1" [value]="cli.CLIENTBANKADDR1 | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIENTBANKADDR1')" />
              </div>
              <div class="field col-12 xl:col-6 sm:col-6">
                <label for="CB8" class="do-not-wrap-text">Доп адрес банка</label>
                <input id="CB8" type="text" pInputText [(ngModel)]="cli.CLENTBANKADDR2" [value]="cli.CLENTBANKADDR2 | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLENTBANKADDR2')" />
              </div>
              <div class="field col-12">
                <label for="CB0" class="do-not-wrap-text">Второй расчетный счет (используется в формах вместо основного, если указан)</label>
                <input id="CB0" type="text" pInputText [(ngModel)]="cli.CLIENTBANK2ACC" [value]="cli.CLIENTBANK2ACC | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIENTBANK2ACC')" />
              </div>
            </div>
          </p-panel>
          <p-panel header="Прочее" styleClass="mb-3">
            <div class="fluid formgrid grid">
              <div class="col xl:col-3 sm:col-12">
                <app-customercategoryselector labelKey="Группа компаний"
                                              [selectedID]="cli.CASTCATID"
                                              [groupname]="cli.CLIENTSNIKNAME | pipetrimstr"
                                              (selectedCategoryID)="cs2Selected($event)"></app-customercategoryselector>
              </div>
              <div class="col xl:col-3 sm:col-12">
                <app-currencyselector labelKey="Валюта баланса" [selectedID]="cli.CURID" (SelectedCurrency)="cs1Selected($event)"></app-currencyselector>
              </div>
              <div class="field col xl:col-3 sm:col-12">
                <label for="CO1" class="do-not-wrap-text">Префикс документов</label>
                <input id="CO1" type="text" pInputText [(ngModel)]="cli.CLIDOCINDEX" [value]="cli.CLIDOCINDEX | pipetrimstr "
                       [class.field-changed]="hasChangedProperty('CLIDOCINDEX')" />
              </div>
              <div class="col xl:col-3 sm:col-12">
                <app-customer-business-area-selector [customerId]="cli.CLIID" (selectedBusinessArea)="onselectedBusinessArea($event)" labelKey="Вертикальный рынок" [disabled]="cli.CLIID==-2">

                </app-customer-business-area-selector>
              </div>
            </div>
          </p-panel>
          <div class="grid formgrid justify-content-end">
            <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="mr-2" [disabled]="clientDoesNotChanged"></p-button>
          </div>
        </p-panel>

        <app-company-director-quick-set
          [cliId]="_cliId"
          [extractedDirectorName]="pendingDirectorName"
          [existingPersons]="persons"
          (personChanged)="onDirectorPersonChanged($event)">
        </app-company-director-quick-set>

        <!-- Company Images -->
        <div class="grid mt-4">

          <!-- Logo -->
          <div class="col-12 md:col-6">
            <p-fieldset legend="Логотип компании" [toggleable]="false">
              <div class="flex flex-column align-items-center gap-2">
                <img *ngIf="logoDataUrl"
                     [src]="logoDataUrl" alt="Логотип"
                     style="max-width:200px; max-height:120px; border:1px solid #ddd; border-radius:4px; object-fit:contain;">
                <span *ngIf="!logoDataUrl" class="text-500 text-sm">Логотип не загружен</span>
                <div class="flex gap-2 mt-2">
                  <label class="p-button p-button-sm p-button-outlined"
                         [class.p-disabled]="logoUploading || !_cliId || _cliId <= 0">
                    <i class="pi pi-upload mr-1"></i> Загрузить
                    <input type="file" accept="image/*" style="display:none"
                           [disabled]="logoUploading || !_cliId || _cliId <= 0"
                           (change)="onLogoFileSelected($event)">
                  </label>
                  <p-button *ngIf="logoDataUrl" icon="pi pi-trash" label="Удалить"
                            styleClass="p-button-sm p-button-danger p-button-outlined"
                            [loading]="logoUploading"
                            (onClick)="onLogoDelete()">
                  </p-button>
                </div>
                <small class="text-500">PNG, JPG, GIF — максимум 5 МБ</small>
              </div>
            </p-fieldset>
          </div>

          <!-- Stamp / Seal -->
          <div class="col-12 md:col-6">
            <p-fieldset legend="Печать компании" [toggleable]="false">
              <div class="flex flex-column align-items-center gap-2">
                <img *ngIf="stampDataUrl"
                     [src]="stampDataUrl" alt="Печать"
                     style="max-width:200px; max-height:120px; border:1px solid #ddd; border-radius:4px; object-fit:contain;">
                <span *ngIf="!stampDataUrl" class="text-500 text-sm">Печать не загружена</span>
                <div class="flex gap-2 mt-2">
                  <label class="p-button p-button-sm p-button-outlined"
                         [class.p-disabled]="stampUploading || !_cliId || _cliId <= 0">
                    <i class="pi pi-upload mr-1"></i> Загрузить
                    <input type="file" accept="image/*" style="display:none"
                           [disabled]="stampUploading || !_cliId || _cliId <= 0"
                           (change)="onStampFileSelected($event)">
                  </label>
                  <p-button *ngIf="stampDataUrl" icon="pi pi-trash" label="Удалить"
                            styleClass="p-button-sm p-button-danger p-button-outlined"
                            [loading]="stampUploading"
                            (onClick)="onStampDelete()">
                  </p-button>
                </div>
                <small class="text-500">PNG, JPG, GIF — максимум 5 МБ</small>
              </div>
            </p-fieldset>
          </div>

        </div>
      </p-accordionTab>
    </div>
    <div #anchorPersons>
      <p-accordionTab [selected]="tabCliPersonSelected" [cache]="false" [disabled]="!_cliId">
        <ng-template pTemplate="header">
          <h5>Сотрудники</h5>
        </ng-template>
        <app-list-client-persons appStopAccordionHomeEnd [clientId]="_cliId"></app-list-client-persons>
      </p-accordionTab>
    </div>

    <div #anchorDepartments>
      <p-accordionTab [selected]="tabCliDepartmentSelected" [cache]="false" [disabled]="!_cliId">
        <ng-template pTemplate="header">
          <h5>Отделы</h5>
        </ng-template>
        <app-edit-client-departments appStopAccordionHomeEnd [clientId]="_cliId"></app-edit-client-departments>
      </p-accordionTab>
    </div>

    <div #anchorChild>
      <p-accordionTab [selected]="tabCliLcoSelected" [cache]="false" [disabled]="!_cliId">
        <ng-template pTemplate="header">
          <h5>Юридические лица</h5>
        </ng-template>
        <app-list-client-lcos appStopAccordionHomeEnd [clientId]="_cliId"></app-list-client-lcos>
      </p-accordionTab>
    </div>

    <div #anchorBalance>
      <p-accordionTab [selected]="tabCliBalanceSelected" [cache]="false" [disabled]="!_cliId" *ngIf="userAccessGroup >= 50000">
        <ng-template pTemplate="header">
          <h5>Баланс с контрагентом</h5>
        </ng-template>
        <app-list-client-balance-due appStopAccordionHomeEnd [clientId]="_cliId" *ngIf="tabCliBalanceSelected"></app-list-client-balance-due>
      </p-accordionTab>
    </div>

    <div #anchorProducts1>
      <p-accordionTab [selected]="tabListProductsOfCustomerSelected" [cache]="false" [disabled]="!_cliId" (onOpen)="onTabListProductOpen($event)" (onClose)="onTabListProductClose($event)">
        <ng-template pTemplate="header">
          <h5>Все товары контрагента - сводная</h5>
        </ng-template>
        <app-list-products-of-customer appStopAccordionHomeEnd [clientId]="_cliId" *ngIf="tabListProductsOfCustomerSelected"></app-list-products-of-customer>
      </p-accordionTab>
    </div>

    <div #anchorProducts2>
      <p-accordionTab [selected]="tabListProductCustomerTransactionsSelected" [cache]="false" [disabled]="!_cliId">
        <ng-template pTemplate="header">
          <h5>Все товары контрагента - последовательно</h5>
        </ng-template>
        <app-list-products-customers-transactions appStopAccordionHomeEnd [clientId]="_cliId" *ngIf="tabListProductCustomerTransactionsSelected"></app-list-products-customers-transactions>
      </p-accordionTab>
    </div>

    <div #anchorDocuments>
      <p-accordionTab [selected]="tabCliDocumentsSelected" [cache]="false" [disabled]="!_cliId">
        <ng-template pTemplate="header">
          <h5>Все документы контрагента</h5>
        </ng-template>
        <app-list-documents-for-client appStopAccordionHomeEnd [clientId]="_cliId" *ngIf="tabCliDocumentsSelected"></app-list-documents-for-client>
      </p-accordionTab>
    </div>

    <div #anchorClientTier>
      <p-accordionTab [(selected)]="tabAgentTierSelected" [cache]="false" [disabled]="!_cliId" *ngIf="globalsettingsservice.hasSomeRoles('portal-admin')">
        <ng-template pTemplate="header">
          <h5>Рівень клієнта (Agent)</h5>
        </ng-template>
        <app-edit-agent-customer-tier-tab appStopAccordionHomeEnd [cliId]="_cliId" *ngIf="tabAgentTierSelected"></app-edit-agent-customer-tier-tab>
      </p-accordionTab>
    </div>

  </p-accordion>
  <p-scrollTop [threshold]="100"/>

  <!-- AG-25 paste-to-create dialog -->
  <app-agent-paste-to-create
    #pasteToCreateDialog
    (created)="onPasteToCreateCompleted($event)">
  </app-agent-paste-to-create>
</div>
<ng-template #loading>
  <p>Информация загружается...</p>
</ng-template>
